
@if (isGlbViewerActive() && campusBuildingLoadersArray.length > 0) {
  <div class="campus-loaders-overlay-container">
    @for (loader of campusBuildingLoadersArray; track loader.perimeterId) {
      @if (loader.visible && loader.status !== 'done') {
        <div
          class="campus-building-loader-pin"
          [style.left.px]="loader.screenX"
          [style.top.px]="loader.screenY"
        >
          <div class="building-loader-card">
            <div class="building-loader-header">
              <i class="fa-solid fa-building-circle-arrow-right fa-spin building-spin-icon"></i>
              <span class="building-name">{{ loader.name }}</span>
            </div>
            <div class="building-loader-status">
              @if (loader.status === 'loading') {
                <span>Loading 3D model...</span>
              } @else if (loader.status === 'building') {
                <span class="floor-text">
                  Building floor <strong>{{ loader.currentFloor }}</strong> of {{ loader.totalFloors }}
                </span>
              }
            </div>
            <div class="building-loader-progress-bar">
              <div
                class="progress-fill"
                [style.width.%]="loader.progressPercent"
              ></div>
            </div>
          </div>
        </div>
      }
    }
  </div>
}
